import { render } from "./WomensHealth.vue?vue&type=template&id=88859dd6&scoped=true"
import script from "./WomensHealth.vue?vue&type=script&lang=js"
export * from "./WomensHealth.vue?vue&type=script&lang=js"

import "./WomensHealth.vue?vue&type=style&index=0&id=88859dd6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88859dd6"]])

export default __exports__